import { classNames } from "primereact/utils";

export const tabView = {
  navContainer: ({ props }) => ({
      className: classNames(
          'relative', // Relative positioning.
          { 'overflow-hidden': props.scrollable } // Overflow condition.
      )
  }),
  navContent: 'overflow-y-hidden overscroll-contain overscroll-auto scroll-smooth [&::-webkit-scrollbar]:hidden', // Overflow and scrollbar styles.
  previousButton: {
      className: classNames('h-full flex items-center justify-center !absolute top-0 z-20', 'left-0', 'bg-white text-blue-500 w-12 shadow-md rounded-none', 'dark:bg-gray-900 dark:border-blue-900/40 dark:text-white/80 )') // Flex and absolute positioning styles.
  },
  nextButton: {
      className: classNames('h-full flex items-center justify-center !absolute top-0 z-20', 'right-0', 'bg-white text-blue-500 w-12 shadow-md rounded-none', 'dark:bg-gray-900 dark:border-blue-900/40 dark:text-white/80 ') // Flex and absolute positioning styles.
  },
  nav: {
      className: classNames('flex flex-1 gap-6 list-none m-0 p-0', 'bg-transparent border border-0 border-b', 'dark:bg-gray-900 dark:border-blue-900/40 dark:text-white/80 ') // Flex, list, margin, padding, and border styles.
  },
};

export const tabPanel = {
  header: ({ props }) => ({
      className: classNames('mr-0', { 'cursor-default pointer-events-none select-none user-select-none opacity-60': props?.disabled }) // Margin and condition-based styles.
  }),
  headerAction: ({ parent, context }) => {
    return {
      className: classNames(
          'items-center cursor-pointer flex overflow-hidden relative select-none text-decoration-none user-select-none', // Flex and overflow styles.
          'border-b-2 py-3 font-bold rounded-t-md transition-shadow duration-200 m-0', // Border, padding, font, and transition styles.
          'transition-colors duration-200', // Transition duration style.
          'focus:outline-none focus:outline-offset-0 dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)]', // Focus styles.
          {
              'text-allstate-navy after:absolute after:bottom-0 after:left-0 after:right-0 after:h-1 after:bg-allstate-light-blue': parent != null ? parent.props.activeIndex === context.index : false, // Condition-based active styles.
              'text-grey-7': parent != null ? parent.props.activeIndex !== context.index : false // Condition-based active styles.
          }
      ),
      style: { marginBottom: '-2px' } // Negative margin style.
    }
  },
  headerTitle: {
      className: classNames('leading-none whitespace-nowrap') // Leading and whitespace styles.
  },
  content: {
      className: classNames('bg-white border-0 text-gray-700 rounded-bl-md rounded-br-md', 'dark:bg-gray-900 dark:border-blue-900/40 dark:text-white/80') // Background, padding, border, and text styles.
  }
};
    